// removed by extract-text-webpack-plugin
module.exports = {"SideDrawer":"SideDrawer__SideDrawer__dQkB_","Open":"SideDrawer__Open__2YMAM","Close":"SideDrawer__Close__3JnsZ","Logo":"SideDrawer__Logo__1H8ng"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Navigation/SideDrawer/SideDrawer.css
// module id = 107
// module chunks = 3